import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createColumnHelper, Group, useTable } from "@components/mantine";
import { Platform, useQuery } from "@core/api";
import { SourceIdentity } from "@components/resource-identity";
import { GenericGranularPrivilegesTable } from "../GenericGranularPrivilegesTable.js";
import { Locales } from "../../../../strings/Locales.js";
var columnHelper = createColumnHelper();
var columns = [
    columnHelper.accessor("name", {
        header: Locales.format("PrivilegesTable.Sources.column.name.header"),
        cell: function(param) {
            var getValue = param.getValue;
            return /*#__PURE__*/ _jsx(SourceIdentity, {
                source: {
                    name: getValue()
                },
                children: /*#__PURE__*/ _jsx(SourceIdentity.Name, {})
            });
        },
        enableSorting: false
    }),
    columnHelper.accessor("sourceType", {
        header: Locales.format("PrivilegesTable.Sources.column.sourceType.header"),
        cell: function(param) {
            var getValue = param.getValue;
            return /*#__PURE__*/ _jsx(SourceIdentity, {
                source: {
                    sourceType: getValue()
                },
                children: /*#__PURE__*/ _jsxs(Group, {
                    gap: "sm",
                    children: [
                        /*#__PURE__*/ _jsx(SourceIdentity.TypeImage, {
                            size: "md"
                        }),
                        /*#__PURE__*/ _jsx(SourceIdentity.TypeLabel, {
                            size: "sm"
                        })
                    ]
                })
            });
        },
        enableSorting: false
    })
];
var pushDocumentOptions = {
    disabled: {
        value: "NONE",
        label: Locales.format("AccessLevelPicker.option.DENY")
    },
    enabled: {
        value: "ALLOW",
        label: Locales.format("AccessLevelPicker.option.ALLOW")
    }
};
export var SourcesPrivilegesTable = function(props) {
    var store = useTable();
    var query = useQuery({
        queryKey: [
            "basic-source",
            "list"
        ],
        queryFn: /*#__PURE__*/ _async_to_generator(function() {
            var response;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Platform.sourcesInternal.listAll()
                        ];
                    case 1:
                        response = _state.sent();
                        store.setTotalEntries(response.length);
                        return [
                            2,
                            response
                        ];
                }
            });
        })
    });
    var selectOptions = props.targetDomain === "PUSH_DOCUMENT" ? pushDocumentOptions : undefined;
    return /*#__PURE__*/ _jsx(GenericGranularPrivilegesTable, _object_spread({
        store: store,
        columns: columns,
        query: query,
        resourceName: props.name.toLowerCase(),
        options: selectOptions
    }, props));
};

//# sourceMappingURL=SourcesPrivilegesTable.js.map